import BaseSchema from "./base";

class PendingSync extends BaseSchema {
  static primaryKey = "key";
  static tableName = "pendingSyncs";
  static fields = ["key", "projectUuid", "table", "uuid"];

  static getFields() {
    return this.fields;
  }
}

export default PendingSync;
